module.exports = __webpack_public_path__ + "img/about-enterprise4.c54f5871.png";